import { RouteEntry } from "../../shared/routes";
import { HomeIndex } from "./HomeIndex";

export const homeRoutes: Array<RouteEntry> = [
    { path: '/', element: <HomeIndex /> },
];
